<div  class="grid w-full" *ngIf="data()">
    <div class="col-12 md:col-4 lg:col-4 ">
        <div class="card relative w-full flex flex-column gap-2 cursor-pointer" (click)="goDetail('punti-campionamento/lista')"  style="background-color: #d7e3ff !important;box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12);padding: 0.5rem !important;border-radius: 0.5rem !important;" [style.max-height]="maxHeight">
            <div class="absolute top-0 right-0">
                <mat-icon class="icon-2xl text-base cursor-pointer material-symbols-outlined">
                    arrow_forward
                  </mat-icon>
            </div>
            <div class="flex gap-1 justify-content-start py-1">
                <mat-icon class="icon-xl text-base cursor-pointer material-symbols-outlined">
                    pin_drop
                  </mat-icon>
              <div *ngIf="title" class="text-xl font-medium">Punti di Campionamento</div>
            </div>
            <div [class]="'card-content flex flex-column gap-1 '">
                <div class="flex align-items-center justify-content-center text-6xl font-bold h-6rem">{{data().countPuntiCampionamento}}</div>
            </div>
          </div>
          
    </div>
    <div class="col-12 md:col-4 lg:col-4">
        <div class="card relative w-full flex flex-column gap-2 cursor-pointer" (click)="goDetail('controlli')" style="background-color: #f5f3f7 !important;box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12);padding: 0.5rem !important;border-radius: 0.5rem !important;" [style.max-height]="maxHeight">
            <div class="absolute top-0 right-0">
                <mat-icon class="icon-2xl text-base cursor-pointer material-symbols-outlined">
                    arrow_forward
                  </mat-icon>
            </div>
            <div class="flex gap-1 justify-content-start py-1">
                <mat-icon class="icon-xl text-base cursor-pointer material-symbols-outlined">
                    fact_check
                  </mat-icon>
              <div *ngIf="title" class="text-xl font-medium">Controlli</div>
            </div>
            <div [class]="'card-content flex flex-column gap-1 '">
                <div class="flex align-items-center justify-content-center text-6xl font-bold h-6rem">{{data().countControlli}}</div>
            </div>
        </div>          
    </div>
    <div class="col-12 md:col-4 lg:col-4">
        <div class="card relative w-full flex flex-column gap-2 cursor-pointer" (click)="goDetail('controlli')"  style="background-color: #dae2f9 !important;box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12);padding: 0.5rem !important;border-radius: 0.5rem !important;" [style.max-height]="maxHeight">
            <div class="absolute top-0 right-0">
                <mat-icon class="icon-2xl text-base cursor-pointer material-symbols-outlined">
                    arrow_forward
                  </mat-icon>
            </div>
            <div class="flex gap-1 justify-content-start py-1">
                <mat-icon class="icon-xl text-base cursor-pointer material-symbols-outlined">
                    receipt
                  </mat-icon>
              <div *ngIf="title" class="text-xl font-medium">Parametri Controllati</div>
            </div>
            <div [class]="'card-content flex flex-column gap-1 '">
                <div class="flex align-items-center justify-content-center text-6xl font-bold h-6rem">{{data().countDatiPrelievo}}</div>
            </div>
          </div>          
    </div>

  </div>

  

